import React, { useCallback, useEffect } from "react";
import { Form, RadioButtonField, SelectField } from "components/form";
import { useTranslation } from "react-i18next";
import { MenuItem } from "@mui/material";
import { json } from "helpers/data";
import _ from "lodash";
import Info from "assets/images/svg/info_dark.svg";
import { useForm } from "react-hook-form";

const PricingForm = ({ packages,handleSubmit, onPriceLevelChange,onSubsriptionType }) => {
	const { t } = useTranslation("browse-apps");
	const [packageVal, setPackageVal] = React.useState({});
	const [billVal, setBillVal] = React.useState("Monthly");

	const getPackage = useCallback((id) => {
		let defaultPackage;
		if (id) {
			defaultPackage = packages?.find((pack) => pack.id === id);
			onPriceLevelChange(id);
			console.log(defaultPackage)
			setPackageVal(defaultPackage);
		} else {
			defaultPackage = packages?.find((pack) => pack.isDefault === true);
			onPriceLevelChange(defaultPackage?.id);
			console.log(defaultPackage)
			setPackageVal(defaultPackage);
		}
	},[onPriceLevelChange, packages]);

	const handleBilling = (e) => {
		setBillVal(e.target.value);
		onSubsriptionType(e.target.value)
		getDiscountVal();
	};
	const getDiscountVal = useCallback(() => {
		let discount;
		const priceArr = packageVal?.details?.map((detail) => detail.price);
		priceArr?.forEach((element) => {
			if (packageVal?.subscriptionType?.id !== 1) {
				if (billVal !== "Monthly") {
					discount = element?.yearly?.discountPercentage;
				} else {
					discount = element?.monthly?.discountPercentage;
				}
			} else {
				discount = element?.forever?.discountPercentage;
			}
		});
		return discount;
	},[billVal, packageVal]);


	useEffect(() => {
		if (_.isEmpty(packageVal)) {
			getPackage();
		}
		getDiscountVal();
	},[getDiscountVal, getPackage, packageVal]);

	return (
		<>
			<Form
				id="hook-form"
				defaultValues={{
					packages: "",
				}}
				onSubmit={handleSubmit}
			>
				{({ formState: { errors }, watch, setValue, reset }) => {
					if (packages.length > 0){ setValue("packages", packageVal?.id)};
					return (
						<>
							<SelectField
								valueField="id"
								label={t("pricingPlan.packageLabel")}
								id="packages"
								labelField="name"
								rules={{
									required: "errors:required",
								}}
								onChange={(e) => {
									getPackage(e.target.value);
								}}
							>
								{packages?.map((pack) => {
									return (
										<MenuItem key={pack.id} value={pack.id}>
											{`${json(pack.name)} (${
												pack.numberOfLicenses
											})`}
										</MenuItem>
									);
								})}
							</SelectField> 
							 <div onChange={handleBilling} className="bill-offer">
								{packageVal?.subscriptionType?.id !== 1 ? (
									<>
										<RadioButtonField
											id="billMonthly"
											name="billing"
											value="Monthly"
											label={t("pricingPlan.billMonthly")}
											isChecked={packageVal?.subscriptionType?.id !== 1}
										/>
										<RadioButtonField
											id="billyearly"
											name="billing"
											value="Yearly"
											label={t("pricingPlan.billYearly")}
										/>
									</>
								) : (
									<RadioButtonField
										id="billForever"
										name="billing"
										value="Forever"
										label={t("pricingPlan.billForever")}
										isChecked={packageVal?.subscriptionType?.id === 1}
									/>
								)}
								{getDiscountVal() > 0 && (	<span className={`discount ${billVal}`}>{getDiscountVal()}% Off</span>)}
							</div>
						</>
					);
				}}
			</Form>
			 {getDiscountVal() > 0 && (
				<div className="info">
					<img src={Info} alt="info" />
					<p>
						{getDiscountVal()} % off on the first year of any Annual
						Subscription
					</p>
				</div>
			)} 
		</>
	);
};

export default PricingForm;
